import React from 'react';

export const Flame = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3616 5.21342C17.0865 5.98419 18.4947 7.32349 19.3509 9.00757C20.2071 10.6916 20.4595 12.6185 20.066 14.4663C19.6725 16.3141 18.6568 17.9709 17.1887 19.16C15.7206 20.3491 13.8889 20.9984 11.9996 20.9994C10.3837 20.9994 8.80327 20.5247 7.45467 19.6344C6.10607 18.744 5.04863 17.4772 4.41363 15.9912C3.77863 14.5052 3.59403 12.8655 3.88274 11.2755C4.17145 9.6855 4.92076 8.21531 6.03765 7.04742C6.80731 8.12215 7.8229 8.99717 8.99965 9.59942C9.02026 8.27805 9.33217 6.9775 9.91313 5.79051C10.4941 4.60352 11.3298 3.55934 12.3606 2.73242C13.1474 3.78761 14.1763 4.63818 15.3606 5.21242L15.3616 5.21342Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0005 18.0002C12.9519 17.9998 13.8676 17.6379 14.5621 16.9877C15.2566 16.3374 15.678 15.4476 15.7409 14.4983C15.8038 13.549 15.5036 12.6112 14.901 11.875C14.2984 11.1388 13.4385 10.6591 12.4955 10.5332C11.4631 11.457 10.7828 12.7102 10.5705 14.0792C9.80019 13.8908 9.0751 13.5508 8.43752 13.0792C8.25237 13.6425 8.20343 14.2416 8.2947 14.8275C8.38597 15.4133 8.61486 15.9692 8.96258 16.4494C9.3103 16.9297 9.76694 17.3206 10.295 17.5902C10.8231 17.8598 11.4076 18.0003 12.0005 18.0002V18.0002Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
